import React from "react";
import {
  BackdropSection,
  Button,
  SectionContent,
  WalletIcon,
} from "components";
import { copyText } from "utils";
import { useGetWalletAddress } from "api";
import NoDisplay from "../components/NoDisplay";
import QRCode from "react-qr-code";

export default function DepositCrypto({
  currentWalletProps: currentWallet,
  displayPage,
}) {
  const { isLoading, isError, getAddress } = useGetWalletAddress({
    type: currentWallet?.sym,
  });

  if (!displayPage) {
    return <NoDisplay type="receiving" />;
  }

  return (
    <SectionContent>
      {!isLoading && !isError ? (
        <div className="grid grid-cols-1 gap-4 p-2">
          <div className="col-span-1">
            <div className="rounded">
              {getAddress ? (
                <div className="flex flex-col items-center justify-center p-2">
                  <div className="flex items-center justify-center">
                    <WalletIcon type={currentWallet?.type} />
                    <div className="ml-2 font-bold">
                      {currentWallet?.name} Wallet Address
                    </div>
                  </div>

                  <div className="my-3 h-[200px] w-[200px]">
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={getAddress}
                      viewBox={`0 0 256 256`}
                    />
                  </div>

                  <div className="flex flex-col items-center justify-center">
                    <div className="mb-3 text-sm text-center">
                      Select{" "}
                      <span className="font-bold uppercase">
                        {currentWallet?.network}
                      </span>{" "}
                      network to send coins to this address. Send only{" "}
                      <span className="font-bold">
                        {currentWallet?.sym_alt}
                      </span>{" "}
                      into this address. Coins sent to the wrong address or the
                      wrong network can not be recovered.
                    </div>

                    <div className="mb-2 break-all">{getAddress}</div>

                    <Button
                      variant="outlined"
                      label="Copy"
                      labelIcon="ContentCopy"
                      handleClick={() =>
                        copyText(
                          getAddress,
                          "Wallet address successfully copied",
                        )
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center p-4">
                  <div className="text-sm text-gray-500">
                    Generating your {currentWallet?.name} wallet address...
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="relative h-[350px]">
          <BackdropSection open={isLoading || isError} />
        </div>
      )}
    </SectionContent>
  );
}
